export const THEMES = {
  SYSTEM_THEME: 'SYSTEM_THEME',
  LIGHT: 'LIGHT',
  DARK: 'DARK',
};
